export default __webpack_public_path__ + "static/media/diamond-clarity@2x.8407b751.png";